import React from 'react';
import { MyContext } from '../InitialSetup/MyProvider';
import { Button, Table } from 'react-bootstrap';
import { getFixtureDetail, getFixtureDetailMultiGame,getUserTeams, getUserLineUpDetail } from "../WSHelper/WSCallings";
import { Utilities, _isEmpty, _Map } from '../Utilities/Utilities';
import { Sports } from "../JsonFiles";
import { AppSelectedSport, preTeamsList, setValue, SELECTED_GAMET, GameType ,RFContestId} from '../helper/Constants';
import * as WSC from "../WSHelper/WSConstants";
import * as AppLabels from "../helper/AppLabels";
import ls from 'local-storage';
import Images from '../components/images';
import WSManager from "../WSHelper/WSManager";
import InfiniteScroll from 'react-infinite-scroll-component';
import MyTeamViewAllModal from '../Modals/MyTeamViewAllModal/MyTeamViewAllModal';
import CustomHeader from '../components/CustomHeader';
import CountdownTimer from '../views/CountDownTimer';
import FieldViewRight from "./FieldViewRight";
import { NoDataView, MomentDateComponent } from '../Component/CustomComponent';

export default class MyTeams extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            TeamsList: [],
            TotalTeam: [],
            CollectionData: undefined,
            isFromCreateTeam: false,
            hasMore: false,
            isLoaderShow: false,
            offset: 0,
            selectedTeams: [],
            openTeam: '',
            isViewAllShown: false,
            allowCollection: Utilities.getMasterData().a_collection,
            sideView: false,
            fieldViewRightData: [],
            rootitem: [],
            isReverseF: false,
        }
    }

    UNSAFE_componentWillMount() {
        this.setLocationStateData();
    }

    componentDidMount() {
        if (this.state.CollectionData) {
            if (this.state.TeamsList.length === 0) {
                this.getUserLineUpListApi(this.state.CollectionData)
            }
        }
        else {
            
            let sportsId = this.props.match.params.sportsId;
            let collection_master_id = this.props.match.params.collection_master_id;

            sportsId = Sports[sportsId];
            this.FixtureDetail(sportsId, collection_master_id);
            if (sportsId) {
                ls.set('selectedSports', sportsId.toString() || sportsId);
                setValue.setAppSelectedSport(sportsId);
            }
        }
    }

    setLocationStateData() {
        if (this.props.location && this.props.location.state) {
            const { LobyyData, isFromCreateTeam ,TotalTeam} = this.props.location.state;

            let keyName = 'my-teams' + Utilities.getSelectedSportsForUrl() + LobyyData.collection_master_id;
            this.setState({
                CollectionData: LobyyData ? LobyyData : undefined,
                isFromCreateTeam: isFromCreateTeam ? isFromCreateTeam : false,
                TeamsList: (preTeamsList[keyName] && preTeamsList[keyName].length > 0) ? preTeamsList[keyName] : [],
                TotalTeam: TotalTeam ? TotalTeam: []
            })
            setTimeout(() => {
                if(this.headerRef){
                    this.headerRef.GetHeaderProps("lobbyheader", '', '', LobyyData ? LobyyData : '');
                }                
            }, 100);
        }
    }


    sideViewHide = () => {
        this.setState({
            sideView: false,
        })
    }



    createTeam() {
        this.props.history.push({ pathname: '/' })
    }

    getUserLineUpListApi = async (CollectionData) => {
        let param = {
            "sports_id": AppSelectedSport,
            "collection_master_id": CollectionData.collection_master_id,
        }
        this.setState({ isLoaderShow: true })
        let user_data = ls.get('profile');
        var user_unique_id = 0;
        if (user_data && user_data.user_unique_id) {
            user_unique_id = user_data.user_unique_id;
        }
        var api_response_data = await getUserTeams(param, user_unique_id);
        if (api_response_data) {
            this.setState({ isLoaderShow: false })
            this.setState({
                TotalTeam: api_response_data,
                TeamsList: (this.state.allowRevFantasy && SELECTED_GAMET == GameType.DFS) ? api_response_data.filter((obj,idx) => {
                    return (this.state.isReverseF ? obj.is_reverse == "1" : obj.is_reverse != "1");
                }) : api_response_data,
            },()=>{
                let keyName = 'my-teams' + Utilities.getSelectedSportsForUrl() + CollectionData.collection_master_id;
                preTeamsList[keyName] = api_response_data;
            })
        }
    }

    /**
     * @description method to get fixture detail
     */
    FixtureDetail = async (sportsId, collection_master_id) => {
        let param = {
            "sports_id": sportsId,
            "collection_master_id": collection_master_id,
        }
        this.setState({ isLoaderShow: true })
        let methodApi = SELECTED_GAMET == GameType.MultiGame ? getFixtureDetailMultiGame : getFixtureDetail
        var api_response_data = await methodApi(param);

        if (api_response_data) {
            this.setState({ isLoaderShow: false })
            this.setState({
                CollectionData: api_response_data
            }, () => {
                this.getUserLineUpListApi(this.state.CollectionData)
            })
            if(SELECTED_GAMET != GameType.MultiGame && SELECTED_GAMET != GameType.OpenPred){
                WSManager.setPickedGameType(GameType.DFS);
              }
               setTimeout(() => {
                if(this.headerRef){
                    this.headerRef.GetHeaderProps("lobbyheader", '', '', api_response_data ? api_response_data : '');
                }                
            }, 100);
        }
    }



    fetchMoreData = () => {
        this.getUserLineUpListApi()
    }

    createLineup = (CollectionData) => {
        const { allowCollection } = this.state;
        if (CollectionData) {
            WSManager.clearLineup();
            let urlParams = '';
            if (SELECTED_GAMET != GameType.MultiGame || (SELECTED_GAMET == GameType.MultiGame && CollectionData.match_list.length == 1)) {
                urlParams = Utilities.setUrlParams(CollectionData)
            }
            else {
                urlParams = Utilities.replaceAll(CollectionData.collection_name, ' ', '_')
            }
            this.props.history.push({ pathname: '/lineup/' + urlParams, state: { FixturedContest: CollectionData, LobyyData: CollectionData, from: 'MyTeams', isFromMyTeams: true, isFrom: "MyTeams", resetIndex: 1, isReverseF: this.state.isReverseF  } })
        }
    }

    openAllPlayer(item) {
        this.setState({ openTeam: item, isViewAllShown: true })
    }

    onViewAllHide = () => {
        this.setState({ isViewAllShown: false })
    }

    openContestListing() {
        let dateformaturl = Utilities.getUtcToLocal(this.state.CollectionData.season_scheduled_date);
        dateformaturl = new Date(dateformaturl);

        let dateformaturlDate = ("0" + dateformaturl.getDate()).slice(-2)
        let dateformaturlMonth = ("0" + (dateformaturl.getMonth() + 1)).slice(-2)
        dateformaturl = dateformaturlDate + '-' + dateformaturlMonth + '-' + dateformaturl.getFullYear();
        let gametype=SELECTED_GAMET;

        let selectedLineupID = this.state.selectedTeams && this.state.selectedTeams.length > 0 ? this.state.selectedTeams[0].lineup_master_id : '';
        if(gametype == GameType.MultiGame){
            let collectionName = Utilities.replaceAll(this.state.CollectionData.collection_name, ' ', '_');
            let contestListingPath = '/' + Utilities.getSelectedSportsForUrl().toLowerCase() + '/contest-listing/' + this.state.CollectionData.collection_master_id + '/' + collectionName + "-" + dateformaturl + "?sgmty=" +  btoa(SELECTED_GAMET);
            this.props.history.push({ pathname: contestListingPath.toLowerCase(), state: { FixturedContest: this.state.FixtureData, LobyyData: this.state.CollectionData, from: 'MyTeams', lineup_master_id: selectedLineupID, isReverseF: this.state.isReverseF } })
        }
        else{
            let contestListingPath = '/' + Utilities.getSelectedSportsForUrl().toLowerCase() + '/contest-listing/' + this.state.CollectionData.collection_master_id + '/' + this.state.CollectionData.home + "-vs-" + this.state.CollectionData.away + "-" + dateformaturl + "?sgmty=" +  btoa(SELECTED_GAMET);
            this.props.history.push({ pathname: contestListingPath.toLowerCase(), state: { FixturedContest: this.state.CollectionData, LobyyData: this.state.CollectionData, from: 'MyTeams', lineup_master_id: selectedLineupID, isReverseF: this.state.isReverseF, lineupObj: this.state.selectedTeams } })
        }
    }

    cloneLineup(rootItem, teamItem) {
        let urlData = rootItem;
        let dateformaturl = Utilities.getUtcToLocal(urlData.season_scheduled_date);
        dateformaturl = new Date(dateformaturl);
        let dateformaturlDate = ("0" + dateformaturl.getDate()).slice(-2)
        let dateformaturlMonth = ("0" + (dateformaturl.getMonth() + 1)).slice(-2)
        dateformaturl = dateformaturlDate + '-' + dateformaturlMonth + '-' + dateformaturl.getFullYear();

        //count home and away player count to set on local storage
        let homePlayerCount = 0;
        let awayPlayerCount = 0;

        this.getUserLineup(rootItem, teamItem).then((lineupData) => {

            if (lineupData != '') {

                let MasterData = lineupData;
                let lineupArr = lineupData.lineup;

                if (typeof lineupArr != 'undefined' && lineupArr.length > 0) {
                    lineupArr.map((lineupItem, lineupIndex) => {

                        if (lineupItem.team_abbreviation == urlData.home || lineupItem.team_abbr == urlData.home) {
                            homePlayerCount = homePlayerCount + 1;
                        }
                        else {
                            awayPlayerCount = awayPlayerCount + 1;
                        }
                    });
                }

                ls.set('home_player_count', homePlayerCount);
                ls.set('away_player_count', awayPlayerCount);
                ls.set('Lineup_data', lineupArr);
                teamItem['team_name'] = '';
                let lineupPath = '';
                if (urlData.home) {
                    lineupPath = '/lineup/' + urlData.home + "-vs-" + urlData.away + "-" + dateformaturl
                    this.props.history.push({ pathname: lineupPath.toLowerCase(), state: { SelectedLineup: lineupArr, MasterData: MasterData, LobyyData: rootItem, FixturedContest: rootItem, team: teamItem, from: 'editView', rootDataItem: rootItem, isFromMyTeams: true, ifFromSwitchTeamModal: false, resetIndex: 1, isClone: true, teamitem: teamItem, collection_master_id: teamItem.collection_master_id, isReverseF: this.state.isReverseF } });
                }
                else {
                    let pathurl = Utilities.replaceAll(urlData.collection_name, ' ', '_').toLowerCase();
                    lineupPath = '/lineup/' + pathurl + "-" + dateformaturl
                    this.props.history.push({ pathname: lineupPath.toLowerCase(), state: { SelectedLineup: lineupArr, MasterData: MasterData, LobyyData: rootItem, FixturedContest: rootItem, team: teamItem, from: 'editView', rootDataItem: rootItem, isFromMyTeams: true, ifFromSwitchTeamModal: false, resetIndex: 1, isClone: true, teamitem: teamItem, collection_master_id: teamItem.collection_master_id, isReverseF: this.state.isReverseF } });
                }
            }
        });

    }

    async getUserLineup(rootItem, teamItem) {

        let param = {
            "lineup_master_id": teamItem.lineup_master_id,
            "collection_master_id": rootItem.collection_master_id,
            "sports_id": AppSelectedSport,
        }

        let responseJson = await getUserLineUpDetail(param);
        let lineupData = '';

        if (responseJson.response_code == WSC.successCode) {
            lineupData = responseJson.data;
        }

        return lineupData;
    }


    openLineup(rootitem, contestItem, teamitem, isEdit, isFromtab, sideView) {
        const { allowCollection } = this.state;
        this.setState({
            sideView: sideView,
            fieldViewRightData: teamitem,
            rootitem: rootitem
        })
        let urlData = rootitem;
        let dateformaturl = Utilities.getUtcToLocal(urlData.season_scheduled_date);
        dateformaturl = new Date(dateformaturl);
        let dateformaturlDate = ("0" + dateformaturl.getDate()).slice(-2)
        let dateformaturlMonth = ("0" + (dateformaturl.getMonth() + 1)).slice(-2)
        dateformaturl = dateformaturlDate + '-' + dateformaturlMonth + '-' + dateformaturl.getFullYear();

        let lineupPath = '';

        if(sideView == false || isEdit == true){

        if (isEdit == false) {
            if (urlData.home) {
                let fieldViewPath = '/field-view/' + urlData.home + "-vs-" + urlData.away + "-" + dateformaturl
                this.props.history.push({ pathname: fieldViewPath.toLowerCase(), state: { team: teamitem, contestItem: contestItem, rootitem: rootitem, isEdit: isEdit, from: 'MyContest', isFromtab: isFromtab, isFromMyTeams: true, FixturedContest: contestItem, LobyyData: rootitem, resetIndex: 1 } });
            }
            else {
                let pathurl = Utilities.replaceAll(urlData.collection_name, ' ', '_');
                let fieldViewPath = '/field-view/' + pathurl + "-" + dateformaturl
                this.props.history.push({ pathname: fieldViewPath.toLowerCase(), state: { team: teamitem, contestItem: contestItem, rootitem: rootitem, isEdit: isEdit, from: 'MyContest', isFromtab: isFromtab, isFromMyTeams: true, FixturedContest: contestItem, LobyyData: rootitem, resetIndex: 1 } });
            }
        }

        else if (SELECTED_GAMET != GameType.MultiGame) {
            lineupPath = '/lineup/' + urlData.home + "-vs-" + urlData.away + "-" + dateformaturl
            this.props.history.push({ pathname: lineupPath.toLowerCase(), state: { SelectedLineup: this.state.lineupArr, MasterData: this.state.MasterData, LobyyData: _isEmpty(this.state.LobyyData) ? urlData : this.state.LobyyData, FixturedContest: this.state.myContestData, team: this.state.TeamMyContestData, from: 'editView', rootDataItem: urlData, isFromMyTeams: this.state.isFromMyTeams ? this.state.isFromMyTeams : isEdit, ifFromSwitchTeamModal: this.state.ifFromSwitchTeamModal, resetIndex: 1, teamitem: teamitem, collection_master_id: contestItem.collection_master_id, league_id: contestItem.league_id ,isReverseF: this.state.isReverseF  } });
        }
        else {
            let pathurl = Utilities.replaceAll(urlData.collection_name, ' ', '_');
            lineupPath = '/lineup/' + pathurl + "-" + dateformaturl
            this.props.history.push({ pathname: lineupPath.toLowerCase(), state: { SelectedLineup: this.state.lineupArr, MasterData: this.state.MasterData, LobyyData: _isEmpty(this.state.LobyyData) ? urlData : this.state.LobyyData, FixturedContest: this.state.myContestData, team: this.state.TeamMyContestData, from: 'editView', rootDataItem: this.state.rootDataItem, isFromMyTeams: true, ifFromSwitchTeamModal: this.state.ifFromSwitchTeamModal, resetIndex: 1, teamitem: teamitem, collection_master_id: contestItem.collection_master_id, league_id: contestItem.league_id } });
        }
    }
    }

    onSelectTeam = (item) => {
        if (SELECTED_GAMET == GameType.DFS) {
            const tmpArray = this.state.selectedTeams;
            if (tmpArray.includes(item)) {
                const idx = tmpArray.indexOf(item);
                if (idx > -1) {
                    tmpArray.splice(idx, 1);
                }
            } else {
                tmpArray.push(item)
            }
            this.setState({ selectedTeams: tmpArray })
        } else {
            this.setState({ selectedTeams: [item] })
        }
    }
    onAllSelect = () => {
        if(this.state.selectedTeams.length === this.state.TeamsList.length){
            this.setState({
                selectedTeams: []
            })
        }else{
            const tmpArray = [];
            _Map(this.state.TeamsList,(item)=>{
                tmpArray.push(item)
            })
            this.setState({
                selectedTeams: tmpArray
            })
        }
    }

    render() {

        const HeaderOption = {
            back: true,
            isFromCreateTeam: this.state.isFromCreateTeam,
            // title: AppLabels.MY_TEAM,
            fixture: true,
        }
        const {
            hasMore,
            isLoaderShow,
            CollectionData
        } = this.state;

        return (
            <MyContext.Consumer>
                {(context) => (
                    <>
                        <CustomHeader {...this.props} ref={(ref) => this.headerRef = ref} HeaderOption={HeaderOption} />
                    <div className={"web-container account-wrapper my-team-root web-container-fixed" + (WSManager.getIsIOSApp() ? " ios-header-fix" : "")} >
                        <div className="webcontainer-inner">
                            {
                                this.state.TeamsList.length > 0 &&

                                <div className="header-content hide">
                                    <div className="team-img-block">
                                        <img src={CollectionData ? Utilities.teamFlagURL(CollectionData.home_flag) : ''} alt="" />
                                    </div>
                                    <div className="team-header-detail">
                                        <div className="team-header-content">
                                            {
                                                CollectionData && CollectionData.home ?
                                                    <span> <span>{CollectionData.home}</span> <small> {AppLabels.VS} </small> <span>{CollectionData.away}</span></span>
                                                    :
                                                    <span>{CollectionData ? CollectionData.collection_name : ''}</span>
                                            }
                                        </div>

                                        <p>
                                            {
                                                CollectionData && Utilities.showCountDown(CollectionData) ?

                                                    <div className="countdown time-line">
                                                        {CollectionData.game_starts_in && <CountdownTimer deadlineTimeStamp={CollectionData.game_starts_in} currentDateTimeStamp={CollectionData.today} />}
                                                    </div>
                                                    :
                                                    CollectionData &&
                                                    <span className='date'>
                                                        <MomentDateComponent data={{date:CollectionData.season_scheduled_date,format:"D MMM - hh:mm A "}} />
                                                    </span>

                                            }

                                        </p>
                                    </div>
                                    <div className="team-img-block">
                                        <img src={CollectionData ? Utilities.teamFlagURL(CollectionData.away_flag) : ''} alt="" />
                                    </div>
                                </div>

                            }

                            {
                                !this.state.isLoaderShow && this.state.TotalTeam.length < parseInt(Utilities.getMasterData().a_teams) && this.state.TeamsList.length > 0 &&
                                <div className="text-center">
                                    <Button className="btn create-team-button mt15" onClick={() => this.createLineup(CollectionData)}>
                                        <span className="text-uppercase" >{AppLabels.CREATE_NEW_TEAM}</span>
                                    </Button>
                                </div>
                            }
                            {
                                SELECTED_GAMET == GameType.DFS && 
                                <div className="reverse-heading">
                                    <div>{''}</div>
                                    <div className="cursor-pointer d-flex" onClick={() => this.onAllSelect()}><div>{(AppLabels.SELECT + " " + AppLabels.ALL).toLowerCase()}</div> <div className={"select-team-checkbox m-l-sm " + (this.state.selectedTeams.length === this.state.TeamsList.length ? 'selected' : '')} /></div>
                                </div>
                            }

                            <InfiniteScroll
                                dataLength={this.state.TeamsList.length}
                                next={this.fetchMoreData.bind(this)}
                                hasMore={hasMore}
                                scrollableTarget='test'
                                loader={
                                    isLoaderShow == true &&
                                    <h4 className='table-loader'>{AppLabels.LOADING_MSG}</h4>
                                }>
                                <ul className="transaction-list transaction-class-scroll no-height" id="test">
                                    {
                                        this.state.TeamsList && this.state.TeamsList.map((item, index) => {
                                            return (
                                                <li className="my-team-list-item" key={item + index}>
                                                    <div className={"my-teams-item " + (this.state.selectedTeams.includes(item) ? 'selected' : '')}>

                                                        <div className="row-header">
                                                            <div className="name-container">
                                                                <div className="team-name">{item.team_name}</div>
                                                                <div className="contests-joined">{item.total_joined} {AppLabels.CONTEST_JOINED}</div>
                                                            </div>


                                                            <div onClick={() => this.onSelectTeam(item)} className={"select-team-checkbox " + (this.state.selectedTeams.includes(item) ? 'selected' : '')} />
                                                        </div>

                                                        {(Utilities.getMasterData().c_point > 0 || Utilities.getMasterData().vc_point > 0) &&
                                                            <Table>
                                                                <tbody>
                                                                    <tr className={"captain-vice-captain" + ((Utilities.getMasterData().c_point > 0 && Utilities.getMasterData().vc_point <= 0) || (Utilities.getMasterData().c_point <= 0 && Utilities.getMasterData().vc_point > 0) ? ' full-width-content' : '')}>
                                                                        {Utilities.getMasterData().c_point > 0  &&
                                                                            <td>
                                                                                <div className="image-container">
                                                                                    <img className="player-image" alt="" src={Utilities.playerJersyURL(item.c_jersey)} />
                                                                                    <span className="player-post captain">{AppLabels.C.toLowerCase()}</span>
                                                                                </div>



                                                                                <div className="player-name-container">
                                                                                    <div className="player-name">{item.c_name}</div>
                                                                                    <div className="team-vs-team">{item.c_team + " | " + item.c_position}</div>
                                                                                </div>
                                                                            </td>
                                                                        }
                                                                        {Utilities.getMasterData().vc_point > 0 &&
                                                                            <React.Fragment>
                                                                                {
                                                                                   item.vc_team != null &&
            
                                                                                    <td>
                                                                                        
                                                                                        <div className="image-container">
                                                                                            <img alt="" className="player-image" src={Utilities.playerJersyURL(item.vc_jersey)} />
                                                                                            <span className="player-post vice-captain">{AppLabels.VC.toLowerCase()}</span>
                                                                                        </div>
            
                                                                                        <div className="player-name-container">
                                                                                            <div className="player-name">{item.vc_name}</div>
                                                                                            <div className="team-vs-team">{item.vc_team + " | " + item.vc_position}</div>
                                                                                        </div>
                                                                                    </td>
                                                                                }
                                                                            </React.Fragment>
                                                                        }

                                                                    </tr>
                                                                </tbody>
                                                            </Table>
                                                        }    
                                                        {/* </div> */}

                                                        {item.is_pl_team == 1 &&
                                                            <img style={{position:"absolute",top:12,right:100}} src={Images.PL_LOGO} alt="" />

                                                        }
                                                         {(this.state.TotalTeam && this.state.TotalTeam.length < parseInt(Utilities.getMasterData().a_teams)) &&
                                                            <a href id='clone-button' title="Clone this team" className="clone-team mr-3" onClick={() => this.cloneLineup(CollectionData, item)}>
                                                                <i className="icon-copy-ic"></i>
                                                            </a>
                                                        }
                                                        <a href title="Edit this team" className="edit-team ml-2 mr-2" onClick={() => this.openLineup(CollectionData, CollectionData, item, true, null)}>
                                                            <i className="icon-edit-line"></i>
                                                        </a>

                                                        <div className="bottom-row visible-for-desktop" 
                                                            onClick={() => this.openLineup(item, '', item,'', false, true)}
                                                            // onClick={() => this.openAllPlayer(item)}
                                                        >
                                                            <span>{AppLabels.View_All_Players}</span>
                                                            <i className='icon-next-arrow'></i>
                                                        </div>
                                                        <div className="bottom-row visible-for-mobile" 
                                                            onClick={() => this.openLineup(CollectionData, '', item,'', false, false)}
                                                        >
                                                            <span>{AppLabels.View_All_Players}</span>
                                                            <i className='icon-next-arrow'></i>
                                                        </div>

                                                        {this.state.sideView &&
                                                            <FieldViewRight
                                                                SelectedLineup={this.state.lineupArr ? this.state.lineupArr : []}
                                                                MasterData={this.state.masterData}
                                                                LobyyData={this.state.LobyyData}
                                                                FixturedContest={this.state.FixturedContest}
                                                                isFrom={this.state.isFrom}
                                                                isFromUpcoming={true}
                                                                rootDataItem={this.state.rootDataItem}
                                                                team={this.state.team}
                                                                team_name={this.state.teamName}
                                                                resetIndex={1}
                                                                TeamMyContestData={this.state.fieldViewRightData}
                                                                isFromMyTeams={this.state.isFromMyTeams}
                                                                ifFromSwitchTeamModal={this.state.ifFromSwitchTeamModal}
                                                                rootitem={this.state.rootitem}
                                                                sideViewHide={this.sideViewHide}
                                                            />
                                                        }
                                                    </div>

                                                </li>
                                            )
                                        })
                                    }


                                    {
                                        this.state.isViewAllShown &&
                                        <MyTeamViewAllModal CollectionData={CollectionData} openTeam={this.state.openTeam} isViewAllShown={this.state.isViewAllShown} onViewAllHide={this.onViewAllHide} />
                                    }

                                    {
                                        this.state.TeamsList.length == 0 && !this.state.isLoaderShow &&
                                        <NoDataView
                                            BG_IMAGE={Images.no_data_bg_image}
                                            CENTER_IMAGE={Images.BRAND_LOGO_FULL}
                                            MESSAGE_1={AppLabels.NO_TEAM_MSG}
                                            MESSAGE_2={AppLabels.THIS_CONTEST}
                                            BUTTON_TEXT={AppLabels.CREATE_NEW_TEAM}
                                            onClick={() => this.createLineup(this.state.CollectionData)}
                                        />
                                    }
                                </ul>
                            </InfiniteScroll>

                        </div>
                        {
                            this.state.selectedTeams && this.state.selectedTeams.length > 0 &&
                            <Button
                                onClick={() => this.openContestListing()}
                                className="bottom">
                                {AppLabels.JOIN_CONTEST}
                                {this.state.selectedTeams.length > 1 && <span className="my-t-j-width">({AppLabels.WITH_TEAMS.replace('##',this.state.selectedTeams.length)})</span>}
                            </Button>
                        }
                    </div>
                    </>
                )}
            </MyContext.Consumer>
        )
    }
}